import { ShinseiApi } from "@/api/ShinseiApi";
import { ShinseiOption } from "@/types/Option";
import { Shinsei, ShinseiList, ListSearchForm, ShinseiDetailRes, ZanYuukyuuRes, ZanFurikyuuRes, ApprovalData } from "@/types/Shinsei";
import { Flow } from "@/types/SyouninGroup";

export class ShinseiService {

  /**
  * 新規登録をします
  * @param params
  * @returns
  */
  public async create(params: Shinsei): Promise<Shinsei> {
    const api = new ShinseiApi();
    try {
      return await api.create(params);
    } catch (e) {
      throw e;
    }
  }

  /**
  * 再申請します
  * @param params
  * @returns
  */
  public async again(params: Shinsei): Promise<number> {
    const api = new ShinseiApi();
    try {
      return await api.again(params);
    } catch (e) {
      throw e;
    }
  }

  /**
  * 取消を行います
  * @param shinseiId
  * @returns
  */
  public async cancel(shinseiId: number): Promise<Shinsei> {
    const api = new ShinseiApi();
    try {
      return await api.cancel(shinseiId);
    } catch (e) {
      throw e;
    }
  }

  /**
  * 一覧を取得します
  * @param params
  * @returns
  */
  public async getList(params: ListSearchForm): Promise<ShinseiList[]> {
    const api = new ShinseiApi();
    try {
      return await api.list(params);
    } catch (e) {
      throw e;
    }
  }

  /**
  * 申請情報を取得します
  * @param id
  * @param type
  * @returns
  */
  public async getInfo(id: number): Promise<ShinseiDetailRes> {
    const api = new ShinseiApi();
    try {
      return await api.info(id);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 承認処理を行います
   * @param params
   * @returns
   */
    public async approval(data: Shinsei): Promise<Flow[]> {
    const api = new ShinseiApi();
    try {
      return await api.approval(data);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 指定されたパスのオプション取得APIを実行し結果を返します
   * @param path
   * @returns
   */
  public async getShinseiOption(): Promise<ShinseiOption | null> {
    const api = new ShinseiApi()
    try {
      return await api.getShinseiOption()
    } catch (e) {
      console.log(e)
      return null
    }
  }

  /**
   * 確認者による承認を行います
   * @param params
   * @returns
   */
  public async check(data: ApprovalData): Promise<Flow[]> {
    const api = new ShinseiApi();
    try {
      return await api.checkForConfUser(data);
    } catch (e) {
      throw e;
    }
  }

  /**
   * ユーザー毎の残有給数を取得します
   * @param userIdList
   * @returns
   */
  public async zanYuukyuu(userId: number): Promise<ZanYuukyuuRes> {
    const api = new ShinseiApi();
    try {
      return await api.zanYuukyuu(userId);
    } catch (e) {
      throw e;
    }
  }

  /**
   * 未取得の振出日数を取得します
   * @param userId
   * @param koyouKeiyakuId
   * @returns
   */
  public async getZanFurikyuuCount(userId: number, koyouKeiyakuId?: number,): Promise<ZanFurikyuuRes | null> {
    const api = new ShinseiApi();
    try {
      return await api.getZanFurikyuuCount(userId, koyouKeiyakuId);
    } catch (e) {
      throw e;
    }
  }
}
